<template>
  <div>
    <vggrid ref="xGrid" :list="list" tableheight="400" flexname="poditemflex" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :needRowNum="true" :needSelection="true"
            :needBlackRow="false" :needPopMenu="false" :canbeEdit="false" :multiLine="multiLine"
            :total="query.total" @cellClick="cellClick" @cellDblClick="cellDblClick" @pagechange="pagechange">
    </vggrid>
    <div>
      <el-button @click="sureDialog">确定</el-button>
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </div>
</template>
<script>
  import request from  '@/utils/request'
  import vggrid from '../common/vggrid'

  export default {
    name: 'brows',
    props:{
      multiLine: false,
      browscode: {},
      newflg: 0
    },
    data () {
      return {
        list: [],
        browselect: '',
        cols: [],
        filterdata: '',
        query: {
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    async created () {
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      browscode(val1,val2) {
        console.log(val1,val2)
      }
    },
    components: {vggrid},
    methods: {
      async init() {
        console.log('==-=-=-=')
        this.list = []
        this.browselect = ''
        this.cols = []
        this.filterdata = ''
      },
      btnClick (code) {
        this.$emit(code)
      },
      async getBrows () {
/*        this.cols = []
        let brows = await request({
          method: 'get',
          url: '/kfgl/brows/getBrowscolListByBrowscode',
          params: {comid: this.$store.getters.loginUser.usercomid,browscode:this.browscode}
        })
        let column = {}
        if (this.multiLine) {
          column = { type: 'selection',fieldtype: 'I', title: '选择',calculExpr:'', width: 80 }
          this.cols.push(column)
        } else {
          column = { type: 'radio',fieldtype: 'I', title: '选择',calculExpr:'', width: 80 }
          this.cols.push(column)
        }
        column = { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 }
        this.cols.push(column)
        await (async ()=>{
          for (let i=0;i<brows.length;i++) {
            column = {}
            let item = brows[i]
            column.field = item.dsfieldcode
            column.title = item.dsfieldname
            column.fieldtype = item.dsfieldtype
            column.hide = item.dsfieldishide
            column.brows = item.dsfieldbrows
            column.issum = item.dsfieldissum
            if (item.dsfieldishide === 1) {
              this.customCols.push(
                {
                  field: item.dsfieldcode,
                  visible: false
                }
              )
            }
            if (item.dsfieldissum === 1) {
              this.sumcols.push(item.dsfieldcode)
            }
            this.cols.push(column)
          }
        })()
        this.$refs.xGrid.$refs.xTable.reloadColumn(this.cols)*/
      },
      async closeDialog() {
        this.$emit('closeDialog')
      },
      async sureDialog() {
        let returndata,insertflg
        if (this.multiLine) {
          returndata = this.$refs.xGrid.$refs.xFlex.getSelectRecords()
          insertflg = true
        } else {
          if (this.$refs.xGrid.$refs.xFlex.getCurrentRow()!==null) {
            returndata = [this.$refs.xGrid.$refs.xFlex.getCurrentRow()]
          } else {
            returndata = []
          }
          insertflg = false
        }
        this.$emit('sureDialog', returndata,insertflg)
      },
      async cellClick (row) {
        this.lebc = row.row
      },
      async cellDblClick (row) {
        let returndata,insertflg
        if (this.multiLine) {
          insertflg = true
        } else {
          insertflg = false
        }
        if (this.$refs.xGrid.$refs.xFlex.getCurrentRow()!==null) {
          returndata = [this.$refs.xGrid.$refs.xFlex.getCurrentRow()]
        } else {
          returndata = []
        }
        this.$emit('sureDialog', returndata,insertflg)
      },
      async pagechange (lebcPage) {
        this.query.currPage = lebcPage.currentPage
        this.query.pageSize = lebcPage.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/brows/getBrowsPageList',
          params: ({comid: this.$store.getters.loginUser.usercomid,browscode: this.browscode})
        })
        this.list = res
        //this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

  .cmplex-filter .f-type {
    padding: 8px 8px 12px 2px;
  }
  .cmplex-filter .f-iscase {
    padding: 12px 8px 6px 2px;
  }
  .cmplex-filter .f-footer {
    text-align: center;
  }

</style>
